/**
 * @description Registers global styles that style all FilePond components
 */

import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import { lighten } from '@mui/system';

import 'filepond/dist/filepond.min.css';

const styles = (
  <GlobalStyles styles={(theme) => (
    {
      '.filepond--wrapper': {
        overflow: 'hidden'
      },

      '.filepond--root': {
        fontFamily: theme.typography.fontFamily,
        margin: 0,

        '.filepond--panel-root': {
          border: 0,
          backgroundColor: theme.palette.background.default
        },

        '.filepond--drop-label': {
          color: theme.palette.text.primary
        },

        '.filepond--label-action': {
          color: theme.palette.primary.main,
          textDecorationColor: theme.palette.primary.main
        },

        '.filepond--item': {
          minHeight: '44px',

          '.filepond--item-panel': {
            backgroundColor: theme.palette.success.main
          },

          '.filepond--file': {
            alignItems: 'center',
            minHeight: '44px',

            '.filepond--file-info': {
              color: theme.palette.success.contrastText,
              fontWeight: theme.typography.fontWeightBold
            },

            '.filepond--file-info-main': {
              fontSize: 'inherit'
            },

            '.filepond--file-info-sub': {
              display: 'none'
            }
          },

          '.filepond--file-status': {
            display: 'none'
          },

          '.filepond--process-indicator': {
            color: theme.palette.success.main,
            marginTop: '0.05em'
          },

          '.filepond--action-retry-item-processing': {
            display: 'none'
          },

          '.filepond--file-action-button': {
            color: theme.palette.success.main,
            cursor: 'pointer',
            backgroundColor: theme.palette.common.white,
            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

            '&:active': {
              backgroundColor: lighten(theme.palette.success.main, 0.75)
            },

            '&:hover': {
              backgroundColor: lighten(theme.palette.success.main, 0.75),
              boxShadow: 'none'
            },

            '&:focus': {
              backgroundColor: lighten(theme.palette.success.main, 0.75),
              boxShadow: 'none'
            },

            svg: {
              transform: 'scale(1.25)'
            }
          },

          '&[data-filepond-item-state*="invalid"], &[data-filepond-item-state*="error"]': {
            '.filepond--item-panel': {
              backgroundColor: theme.palette.error.main
            },

            '.filepond--file': {
              '.filepond--file-info': {
                color: theme.palette.error.contrastText
              }
            },

            '.filepond--file-action-button': {
              color: theme.palette.error.main,

              '&:active': {
                backgroundColor: lighten(theme.palette.error.main, 0.75)
              },

              '&:hover': {
                backgroundColor: lighten(theme.palette.error.main, 0.75)
              },

              '&:focus': {
                backgroundColor: lighten(theme.palette.error.main, 0.75)
              }
            }
          }
        }
      }
    }
  )}
  />
);

export default styles;
